import HttpClient from './utils/HttpClient';
import api from './api';

class NewsletterService {
  constructor() {
    this.httpClient = new HttpClient();
  }

  async subscribeToNewsletter(data) {
    return await this.httpClient.publicPost('/newsletter/leads', data);
  }

  async getLeads(params) {
    const response = await api.get('/newsletter/leads', { params });
    return response.data;
  }

  async exportLeads(scope) {
    const response = await api.post(
      '/newsletter/leads/export',
      { scope },
      { responseType: 'blob' }
    );
    const contentDisposition = response.headers['content-disposition'] || '';
    const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);

    return {
      blob: response.data,
      filename: filenameMatch?.[1] || 'newsletter-leads.csv',
    };
  }
}

export default new NewsletterService();
